module.exports = __webpack_public_path__ + "img/qy (45).0d4ec9cf.jpg";